import React from 'react';

function StaffDetails({
  selectedUser,
  handleChange,
  editedUser,
  isEditing,
  handleEditClick,
  handleSaveClick,
  handleCancelClick,
  loading
}) {
  console.log('Selected User:', selectedUser);

  const formatDateForInput = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return dateString;
    return date.toISOString().split("T")[0];
  };

  const formatDateForDisplay = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return dateString;
    return date.toLocaleDateString("en-GB");
  };

  return (
    <div className="registration-container">
      <div className="studentdetailedit">
        <h2>Staff Details</h2>
        <div className="button-group">
          {isEditing ? (
            <>
              <button
                className="Save-profile-custom-button"
                onClick={handleSaveClick}
                disabled={loading}
              >
                {loading ? 'Saving...' : 'Save'}
              </button>
              <button
                className="Cancel-profile-custom-button"
                onClick={handleCancelClick}
                disabled={loading}
              >
                Cancel
              </button>
            </>
          ) : (
            <button
              className="discord-profile-custom-button"
              onClick={handleEditClick}
            >
              Edit Profile
            </button>
          )}
        </div>
      </div>

      <div className="registration-form">
        {/* Basic Information */}
        <h3>Basic Information</h3>
        <div className="basicinfostudentdetail">
          <div className="form-row">
            <div className="form-group">
              <label htmlFor="firstName">First Name: <span className="required-star">*</span></label>
              {isEditing ? (
                <input
                  type="text"
                  id="firstName"
                  name="user.firstName"
                  value={editedUser?.user?.firstName || ""}
                  onChange={handleChange}
                  placeholder="First Name"
                />
              ) : (
                <span className="InfoValue">{selectedUser?.rawData?.user?.firstName || selectedUser?.firstName || "N/A"}</span>
              )}
            </div>
            <div className="form-group">
              <label htmlFor="middleName">Middle Name:</label>
              {isEditing ? (
                <input
                  type="text"
                  id="middleName"
                  name="user.middleName"
                  value={editedUser?.user?.middleName || ""}
                  onChange={handleChange}
                  placeholder="Middle Name"
                />
              ) : (
                <span className="InfoValue">{selectedUser?.rawData?.user?.middleName || selectedUser?.middleName || "N/A"}</span>
              )}
            </div>
            <div className="form-group">
              <label htmlFor="lastName">Last Name: <span className="required-star">*</span></label>
              {isEditing ? (
                <input
                  type="text"
                  id="lastName"
                  name="user.lastName"
                  value={editedUser?.user?.lastName || ""}
                  onChange={handleChange}
                  placeholder="Last Name"
                />
              ) : (
                <span className="InfoValue">{selectedUser?.rawData?.user?.lastName || selectedUser?.lastName || "N/A"}</span>
              )}
            </div>
          </div>
          <div className="form-row">
            <div className="form-group">
              <label htmlFor="gender">Gender: <span className="required-star">*</span></label>
              {isEditing ? (
                <select
                  id="gender"
                  name="user.gender"
                  value={editedUser?.user?.gender || ""}
                  onChange={handleChange}
                >
                  <option value="">Select Gender</option>
                  <option value="MALE">Male</option>
                  <option value="FEMALE">Female</option>
                  <option value="OTHER">Other</option>
                </select>
              ) : (
                <span className="InfoValue">{selectedUser?.rawData?.user?.gender || selectedUser?.gender || "N/A"}</span>
              )}
            </div>
            <div className="form-group">
              <label htmlFor="dob">Date of Birth: <span className="required-star">*</span></label>
              {isEditing ? (
                <input
                  type="date"
                  id="dob"
                  name="user.dateOfBirth"
                  value={formatDateForInput(editedUser?.user?.dateOfBirth) || ""}
                  onChange={handleChange}
                />
              ) : (
                <span className="InfoValue">{selectedUser?.rawData?.user?.dateOfBirth ? formatDateForDisplay(selectedUser.rawData.user.dateOfBirth) : "N/A"}</span>
              )}
            </div>
            <div className="form-group">
              <label htmlFor="placeOfBirth">Place of Birth:</label>
              {isEditing ? (
                <input
                  type="text"
                  id="placeOfBirth"
                  name="user.placeOfBirth"
                  value={editedUser?.user?.placeOfBirth || ""}
                  onChange={handleChange}
                  placeholder="Place of Birth"
                />
              ) : (
                <span className="InfoValue">{selectedUser?.rawData?.user?.placeOfBirth || selectedUser?.placeOfBirth || "N/A"}</span>
              )}
            </div>
          </div>
          <div className="form-row">
            <div className="form-group">
              <label htmlFor="bloodGroup">Blood Group:</label>
              {isEditing ? (
                <select
                  id="bloodGroup"
                  name="user.bloodGroup"
                  value={editedUser?.user?.bloodGroup || ""}
                  onChange={handleChange}
                >
                  <option value="">Select Blood Group</option>
                  <option value="A_POSITIVE">A+</option>
                  <option value="A_NEGATIVE">A-</option>
                  <option value="B_POSITIVE">B+</option>
                  <option value="B_NEGATIVE">B-</option>
                  <option value="O_POSITIVE">O+</option>
                  <option value="O_NEGATIVE">O-</option>
                  <option value="AB_POSITIVE">AB+</option>
                  <option value="AB_NEGATIVE">AB-</option>
                </select>
              ) : (
                <span className="InfoValue">{selectedUser?.rawData?.user?.bloodGroup || selectedUser?.bloodGroup || "N/A"}</span>
              )}
            </div>
            <div className="form-group">
              <label htmlFor="nationality">Nationality:</label>
              {isEditing ? (
                <input
                  type="text"
                  id="nationality"
                  name="user.nationality"
                  value={editedUser?.user?.nationality || ""}
                  onChange={handleChange}
                  placeholder="Nationality"
                />
              ) : (
                <span className="InfoValue">{selectedUser?.rawData?.user?.nationality || selectedUser?.nationality || "N/A"}</span>
              )}
            </div>
            <div className="form-group">
              <label htmlFor="religion">Religion:</label>
              {isEditing ? (
                <input
                  type="text"
                  id="religion"
                  name="user.religion"
                  value={editedUser?.user?.religion || ""}
                  onChange={handleChange}
                  placeholder="Religion"
                />
              ) : (
                <span className="InfoValue">{selectedUser?.rawData?.user?.religion || selectedUser?.religion || "N/A"}</span>
              )}
            </div>
          </div>
          <div className="form-row">
            <div className="form-group">
              <label htmlFor="category">Category:</label>
              {isEditing ? (
                <input
                  type="text"
                  id="category"
                  name="user.category"
                  value={editedUser?.user?.category || ""}
                  onChange={handleChange}
                  placeholder="Category"
                />
              ) : (
                <span className="InfoValue">{selectedUser?.rawData?.user?.category || selectedUser?.category || "N/A"}</span>
              )}
            </div>
            <div className="form-group">
              <label htmlFor="email">Email: <span className="required-star">*</span></label>
              {isEditing ? (
                <input
                  type="email"
                  id="email"
                  name="user.email"
                  value={editedUser?.user?.email || ""}
                  onChange={handleChange}
                  placeholder="example@gmail.com"
                />
              ) : (
                <span className="InfoValue">{selectedUser?.rawData?.user?.email || selectedUser?.email || "N/A"}</span>
              )}
            </div>
            <div className="form-group">
              <label htmlFor="phoneNumber">Phone Number: <span className="required-star">*</span></label>
              {isEditing ? (
                <input
                  type="text"
                  id="phoneNumber"
                  name="user.phoneNumber"
                  value={editedUser?.user?.phoneNumber || ""}
                  onChange={handleChange}
                  placeholder="Phone Number"
                />
              ) : (
                <span className="InfoValue">{selectedUser?.rawData?.user?.phoneNumber || selectedUser?.phoneNumber || "N/A"}</span>
              )}
            </div>
          </div>
          <div className="form-row">
            <div className="form-group">
              <label htmlFor="lastFourDigitsOfAadhaarNumber">Last Four Digits of Aadhaar:</label>
              {isEditing ? (
                <input
                  type="text"
                  id="lastFourDigitsOfAadhaarNumber"
                  name="user.lastFourDigitsOfAadhaarNumber"
                  value={editedUser?.user?.lastFourDigitsOfAadhaarNumber || ""}
                  onChange={(e) => {
                    const value = e.target.value.replace(/\D/g, "").slice(-4);
                    handleChange({ target: { name: "user.lastFourDigitsOfAadhaarNumber", value } });
                  }}
                  placeholder="Last Four Digits"
                  maxLength="4"
                />
              ) : (
                <span className="InfoValue">{selectedUser?.rawData?.user?.lastFourDigitsOfAadhaarNumber || selectedUser?.lastFourDigitsOfAadhaarNumber || "N/A"}</span>
              )}
            </div>
          </div>
        </div>

        {/* Contact Information */}
        <h3>Contact Information</h3>
        <div className="basicinfostudentdetail">
          <div className="form-row">
            <div className="form-group">
              <label htmlFor="city">City: <span className="required-star">*</span></label>
              {isEditing ? (
                <input
                  type="text"
                  id="city"
                  name="user.addressDetails.0.city"
                  value={editedUser?.user?.addressDetails?.[0]?.city || ""}
                  onChange={handleChange}
                  placeholder="City"
                />
              ) : (
                <span className="InfoValue">{selectedUser?.rawData?.user?.addressDetails?.[0]?.city || "N/A"}</span>
              )}
            </div>
            <div className="form-group">
              <label htmlFor="state">State:</label>
              {isEditing ? (
                <input
                  type="text"
                  id="state"
                  name="user.addressDetails.0.state"
                  value={editedUser?.user?.addressDetails?.[0]?.state || ""}
                  onChange={handleChange}
                  placeholder="Enter State"
                />
              ) : (
                <span className="InfoValue">{selectedUser?.rawData?.user?.addressDetails?.[0]?.state || "N/A"}</span>
              )}
            </div>
            <div className="form-group">
              <label htmlFor="pincode">Pincode:</label>
              {isEditing ? (
                <input
                  type="text"
                  id="pincode"
                  name="user.addressDetails.0.pinCode"
                  value={editedUser?.user?.addressDetails?.[0]?.pinCode || ""}
                  onChange={handleChange}
                  placeholder="Enter Pincode"
                />
              ) : (
                <span className="InfoValue">{selectedUser?.rawData?.user?.addressDetails?.[0]?.pinCode || "N/A"}</span>
              )}
            </div>
          </div>
          <div className="form-row">
            <div className="form-group">
              <label htmlFor="country">Country:</label>
              {isEditing ? (
                <input
                  type="text"
                  id="country"
                  name="user.addressDetails.0.country"
                  value={editedUser?.user?.addressDetails?.[0]?.country || ""}
                  onChange={handleChange}
                  placeholder="Enter Country"
                />
              ) : (
                <span className="InfoValue">{selectedUser?.rawData?.user?.addressDetails?.[0]?.country || "N/A"}</span>
              )}
            </div>
            <div className="form-group">
              <label htmlFor="currentAddress">Address Line 1:</label>
              {isEditing ? (
                <input
                  type="text"
                  id="currentAddress"
                  name="user.addressDetails.0.addressLine1"
                  value={editedUser?.user?.addressDetails?.[0]?.addressLine1 || ""}
                  onChange={handleChange}
                  placeholder="Address Line 1"
                />
              ) : (
                <span className="InfoValue">{selectedUser?.rawData?.user?.addressDetails?.[0]?.addressLine1 || "N/A"}</span>
              )}
            </div>
            <div className="form-group">
              <label htmlFor="currentAddress2">Address Line 2:</label>
              {isEditing ? (
                <input
                  type="text"
                  id="currentAddress2"
                  name="user.addressDetails.0.addressLine2"
                  value={editedUser?.user?.addressDetails?.[0]?.addressLine2 || ""}
                  onChange={handleChange}
                  placeholder="Address Line 2"
                />
              ) : (
                <span className="InfoValue">{selectedUser?.rawData?.user?.addressDetails?.[0]?.addressLine2 || "N/A"}</span>
              )}
            </div>
          </div>
          <div className="form-row">
            <div className="form-group">
              <label htmlFor="alternatePhoneNumber">Alternate Contact Number:</label>
              {isEditing ? (
                <input
                  type="text"
                  id="alternatePhoneNumber"
                  name="user.addressDetails.0.alternatePhoneNumber"
                  value={editedUser?.user?.addressDetails?.[0]?.alternatePhoneNumber || ""}
                  onChange={handleChange}
                  placeholder="Alternate Contact Number"
                />
              ) : (
                <span className="InfoValue">{selectedUser?.rawData?.user?.addressDetails?.[0]?.alternatePhoneNumber || "N/A"}</span>
              )}
            </div>
          </div>
        </div>

        {/* Staff Information */}
        <h3>Staff Information</h3>
        <div className="basicinfostudentdetail">
          <div className="form-row">
            <div className="form-group">
              <label htmlFor="employeeId">Employee ID: <span className="required-star">*</span></label>
              {isEditing ? (
                <input
                  type="text"
                  id="employeeId"
                  name="staffInfo.employeeId"
                  value={editedUser?.staffInfo?.employeeId || ""}
                  onChange={handleChange}
                  placeholder="Employee ID"
                />
              ) : (
                <span className="InfoValue">{selectedUser?.rawData?.staffInfo?.employeeId || "N/A"}</span>
              )}
            </div>
            <div className="form-group">
              <label htmlFor="designation">Designation: <span className="required-star">*</span></label>
              {isEditing ? (
                <input
                  type="text"
                  id="designation"
                  name="staffInfo.designation"
                  value={editedUser?.staffInfo?.designation || ""}
                  onChange={handleChange}
                  placeholder="Designation"
                />
              ) : (
                <span className="InfoValue">{selectedUser?.rawData?.staffInfo?.designation || "N/A"}</span>
              )}
            </div>
            <div className="form-group">
              <label htmlFor="department">Department: <span className="required-star">*</span></label>
              {isEditing ? (
                <input
                  type="text"
                  id="department"
                  name="staffInfo.department"
                  value={editedUser?.staffInfo?.department || ""}
                  onChange={handleChange}
                  placeholder="Department"
                />
              ) : (
                <span className="InfoValue">{selectedUser?.rawData?.staffInfo?.department || "N/A"}</span>
              )}
            </div>
          </div>
          <div className="form-row">
            <div className="form-group">
              <label htmlFor="joiningDate">Joining Date: <span className="required-star">*</span></label>
              {isEditing ? (
                <input
                  type="date"
                  id="joiningDate"
                  name="staffInfo.joiningDate"
                  value={formatDateForInput(editedUser?.staffInfo?.joiningDate) || ""}
                  onChange={handleChange}
                />
              ) : (
                <span className="InfoValue">{selectedUser?.rawData?.staffInfo?.joiningDate ? formatDateForDisplay(selectedUser.rawData.staffInfo.joiningDate) : "N/A"}</span>
              )}
            </div>
            <div className="form-group">
              <label htmlFor="staffContractType">Contract Type: <span className="required-star">*</span></label>
              {isEditing ? (
                <select
                  id="staffContractType"
                  name="staffInfo.staffContractType"
                  value={editedUser?.staffInfo?.staffContractType || ""}
                  onChange={handleChange}
                >
                  <option value="">Select Contract Type</option>
                  <option value="PERMANENT">Permanent</option>
                  <option value="TEMPORARY">Temporary</option>
                  <option value="CONTRACT">Contract</option>
                </select>
              ) : (
                <span className="InfoValue">{selectedUser?.rawData?.staffInfo?.staffContractType || "N/A"}</span>
              )}
            </div>
            <div className="form-group">
              <label htmlFor="responsibilities">Responsibilities:</label>
              {isEditing ? (
                <input
                  type="text"
                  id="responsibilities"
                  name="staffInfo.responsibilities"
                  value={
                    Array.isArray(editedUser?.staffInfo?.responsibilities)
                      ? editedUser.staffInfo.responsibilities.join(", ")
                      : ""
                  }
                  onChange={(e) => {
                    const value = e.target.value;
                    const responsibilities = value.split(",").map(item => item.trim()).filter(item => item !== "");
                    handleChange({
                      target: {
                        name: "staffInfo.responsibilities",
                        value: responsibilities
                      }
                    });
                  }}
                  placeholder="Responsibilities"
                />
              ) : (
                <span className="InfoValue">
                  {Array.isArray(selectedUser?.rawData?.staffInfo?.responsibilities)
                    ? selectedUser.rawData.staffInfo.responsibilities.join(", ") || "N/A"
                    : "N/A"}
                </span>
              )}
            </div>
          </div>
          <div className="form-row">
            <div className="form-group">
              <label htmlFor="identificationMark">Identification Mark:</label>
              {isEditing ? (
                <input
                  type="text"
                  id="identificationMark"
                  name="staffInfo.identificationMark"
                  value={editedUser?.staffInfo?.identificationMark || ""}
                  onChange={handleChange}
                  placeholder="Identification Mark"
                />
              ) : (
                <span className="InfoValue">{selectedUser?.rawData?.staffInfo?.identificationMark || "N/A"}</span>
              )}
            </div>
            <div className="form-group">
              <label htmlFor="drivingLicenseNumber">Driving License Number:</label>
              {isEditing ? (
                <input
                  type="text"
                  id="drivingLicenseNumber"
                  name="staffInfo.drivingLicenseNumber"
                  value={editedUser?.staffInfo?.drivingLicenseNumber || ""}
                  onChange={handleChange}
                  placeholder="Driving License Number"
                />
              ) : (
                <span className="InfoValue">{selectedUser?.rawData?.staffInfo?.drivingLicenseNumber || "N/A"}</span>
              )}
            </div>
            <div className="form-group">
              <label htmlFor="drivingLicenseValidity">Driving License Validity:</label>
              {isEditing ? (
                <input
                  type="date"
                  id="drivingLicenseValidity"
                  name="staffInfo.drivingLicenseValidity"
                  value={formatDateForInput(editedUser?.staffInfo?.drivingLicenseValidity) || ""}
                  onChange={handleChange}
                />
              ) : (
                <span className="InfoValue">{selectedUser?.rawData?.staffInfo?.drivingLicenseValidity ? formatDateForDisplay(selectedUser.rawData.staffInfo.drivingLicenseValidity) : "N/A"}</span>
              )}
            </div>
          </div>
          <div className="form-row">
            <div className="form-group">
              <label htmlFor="drivingExperienceYears">Driving Experience (Years):</label>
              {isEditing ? (
                <input
                  type="number"
                  id="drivingExperienceYears"
                  name="staffInfo.drivingExperienceYears"
                  value={editedUser?.staffInfo?.drivingExperienceYears || ""}
                  onChange={handleChange}
                  placeholder="Driving Experience Years"
                  min="0"
                />
              ) : (
                <span className="InfoValue">{selectedUser?.rawData?.staffInfo?.drivingExperienceYears || "N/A"}</span>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default StaffDetails;